<template>

  <Loader v-if="loading"/>
  <section v-else class="dashboard__data">
    <div class="container-fluid pb-24">
      <div class="dashboard__list" :class="{'show': $store.getters.isDisplayList}">
        <div class="dashboard__table__row dashboard__table__header">

          <div class="dashboard__table__column" style="width: 20%;">
            {{ $lang.app.FROM_WHOM }}
          </div>
          <div class="dashboard__table__column" style="width: 30%;">
            {{ $lang.app.MESSAGE }}
          </div>
          <div class="dashboard__table__column" style="width: 21%;">
            {{ $lang.app.APPLICATION }}
          </div>
          <div class="dashboard__table__column" style="width: 8.5%;">
            {{ $lang.app.DATE }}
          </div>
          <div class="dashboard__table__column" style="width: 20.5%;">
            {{ $lang.app.STATUS }}
          </div>
        </div>
        <ListItem v-for="(inbox, index) in inboxes" :key="index" :inbox="inbox"/>
      </div>
      <div class="dashboard__grid" :class="{'show': $store.getters.isDisplayGrid}">
        <div class="row">
          <div v-for="(inbox, index) in inboxes" :key="index"
               class="col-xxl-3 col-xl-4 col-lg-4">
            <router-link :to="{
                            name: 'ApplicantApplicationsInboxesDetail',
                            params: { inboxId: inbox.id },
                          }"
                         class="dashboard__application__item">
								<span class="dashboard__application__header">
									<span class="dashboard__application__number">{{ inbox.fromUser?.login }}</span>
									<span class="dashboard__application__status blue__medium">{{ inbox.statusText }}</span>
								</span>
              <h3 class="dashboard__application__title">
                <span :class="[ !inbox.read ? 'font-semibold text-gray-900': 'text-gray-600']">{{ inbox.title }}</span>
              </h3>
              <p class="dashboard__application__address">{{ inbox.docExpertise?.name }}</p>
              <span class="dashboard__application__dates">
									<span class="row">
										<span class="col-lg-6">
											<span class="stack__list">
												<span class="stack__label">{{ $lang.app.DATE }}</span>
												<span class="stack__value">{{ $moment(inbox.createdAt).format('DD.MM.YYYY HH:mm') }}</span>
											</span>
										</span>
									</span>
								</span>
            </router-link>
          </div>
        </div>
      </div>
      <Pagination
          v-if="inboxes.length"
          :value="pagination.page"
          @change="changePage"
          :limit="pagination.limit"
          :total-records="pagination.totalRecords"
      />
    </div>
  </section>

</template>
<script>
import requestApi from "../../../../api/applicant/request";
import Pagination from "../../../../components/Pagination.vue";
import PaginationMixin from "../../../../mixins/paginationMixin";
import {getLabelRefByValue as inboxTypesGetLabelRefByValue} from "../../../../helpers/constants/inboxTypes";
import ListItem from "../../../../components/applicant/inbox/ListItem.vue";
export default {
  name: "ApplicantApplicationsInboxesList",
  components: {
    Pagination,
    ListItem,
  },
  mixins: [PaginationMixin],
  data() {
    return {
      loading: false,
      inboxes: [],
    };
  },
  created() {
    this.setupPage();
    this.fetchInboxes();
  },
  watch: {
    '$route.query.page'() {
      this.setupPage()
      this.fetchInboxes()
    }
  },
  methods: {
    inboxTypesGetLabelRefByValue,
    changePage(value) {
      this.$router.push({
        name: 'ApplicantApplicationsInboxesList',
        query: { page: value }
      })
    },
    fetchInboxes() {
      this.loading = true;
      requestApi
          .getRequests({
            type: 'inbox',
            limit: this.pagination.limit,
            page: this.pagination.page,
          })
          .then((data) => {
            this.inboxes = data.list;
            this.pagination.totalRecords = data.totalRecords;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>
